import React from 'react'
import {  
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
    useColorModeValue,
    Text,
  } from '@chakra-ui/react';

export function ButtonSanfona({title, children}) {
    const activeBg = useColorModeValue('brand.500', 'brand.600');
    const hoverBg = useColorModeValue('brand.50', 'whiteAlpha.100');

    return (
      <Accordion allowToggle w="full">
      <AccordionItem border="none">
          <AccordionButton 
            borderRadius="xl"
            _expanded={{ bg: activeBg, color: 'white', shadow: 'md' }}
            _hover={{ bg: hoverBg }}
            py={3} // py=3 no AccordionButton do Chakra resulta em altura similar ao py=6 do Button
            px={4}
            transition="all 0.3s"
          >
            <Box as="span" flex='1' textAlign='left'>
              <Text 
                fontSize="sm" 
                fontWeight="800" 
                letterSpacing="tighter" 
                textTransform="uppercase"
              >
                {title}
              </Text>
            </Box>
            <AccordionIcon />
          </AccordionButton>
      
        <AccordionPanel pb={4} borderLeft="2px solid" borderColor={activeBg} ml={4} mt={2}>
           <Box>
            {children}
           </Box>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>  
    );
}

export default ButtonSanfona;